import moment from "moment";

export function getDeadline(record) {
  return moment(record.phoneServiceReceiveDate || record.createdAt)
    .add(10, "days")
    .toDate();
}
